export const DBS_BANK_RESET_STATE = 'DBS_BANK_RESET_STATE';
export const DBS_BANK_CURRENT_ITEM = 'DBS_BANK_CURRENT_ITEM';

export const DBS_BANK_REQUEST_LOADING = 'DBS_BANK_REQUEST_LOADING';
export const DBS_BANK_REQUEST_SUCCESS = 'DBS_BANK_REQUEST_SUCCESS';
export const DBS_BANK_REQUEST_FAILED = 'DBS_BANK_REQUEST_FAILED';

export const DBS_BANK_CURRENT_ACTION = 'DBS_BANK_CURRENT_ACTION';
export const DBS_BANK_RESET_ACTION = 'DBS_BANK_RESET_ACTION';